import { getRequest } from "../../api/methodsCfg";

export const getAllOrders = async () => {
  const response = await getRequest("/order/all");
  return response;
};
